import $http from "./BaseHttpServices";

export default {
  contactUs(payload) {
    return $http.post("contact-us", payload, {
      headers: { "Content-Type": "application/json" },
    });
  },
};
